import styled from "@mui/system/styled";

const TagWrapper = styled("span")(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.dark}`,
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  borderRadius: "4px",
  color: theme.palette.text.dark,
  background: theme.palette.secondary.light,
  margin: "0 5px",
}));

export const Tags = ({ tags }) => {
  // TODO: tags - should this be an array?
  if (typeof tags === "string" && tags !== "") {
    return (
      <div style={{ textAlign: "left", margin: "15px 0" }}>
        <TagWrapper>{tags}</TagWrapper>
      </div>
    );
  }
  if (Array.isArray(tags)) {
    return (
      <div style={{ textAlign: "left", margin: "15px 0" }}>
        {tags.map(t => {
          return (
              <TagWrapper key={t}>{t}</TagWrapper>
          )
        })}
      </div>
    )
  }
  return null;
};
export default Tags;
